// extracted by mini-css-extract-plugin
export var messageSideLeft = "_li-1";
export var messageSideRight = "_li-2";
export var orderLookupBubbleContainer = "_li-0";
export var submitButton = "_li-3";